import Store from 'redux/store';
import { FETCH_RATING_STORE, FETCH_RATING_STORE_SUCCESS, FETCH_RATING_STORE_FAIL } from 'redux/Reducers/RatingStore/RatingStoreReducer';
import { premmiar } from '../clients';

// eslint-disable-next-line default-param-last
const FetchRatingStore = async (User, finallyCallback = () => {}, { vendorId }) => {
  Store.dispatch({ type: FETCH_RATING_STORE, payload: { vendorId } });
  premmiar(User).get(`/api/RatingAverage/Average?identification=${vendorId}&type=2`).then((response) => {
    Store.dispatch({
      type: FETCH_RATING_STORE_SUCCESS,
      payload: {
        vendorId,
        ...response,
      },
    });
  }).catch((e) => {
    Store.dispatch({
      type: FETCH_RATING_STORE_FAIL, payload: { vendorId }, error: e,
    });
  })
    .finally(() => {
      finallyCallback();
    });
};

export default FetchRatingStore;
